module.exports = __webpack_public_path__ + "static/media/botones-15.e07976ce.png";